import { useLocalStorage } from '@buffer-mono/popcorn'

import { useOrganizationId } from '~publish/contexts/AccountContext'
import {
  newCalendarSingleChannel,
  scheduleCalendar,
  channel as channelRoute,
  channelSchedule,
} from '~publish/legacy/routes'
import { usePostCounts } from '~publish/pages/AllChannels/PostList/usePostCounts'

import useMatchCurrentOrParentPath from './useMatchCurrentOrParentPath'

const STORE_KEY = 'showTimeSlots'

export function useSlotsEnabled(): [boolean, (enabled: boolean) => void] {
  const singleChannelCalendarMatch = useMatchCurrentOrParentPath(
    newCalendarSingleChannel.route,
  )
  const allChannelsCalendarMatch = useMatchCurrentOrParentPath(
    scheduleCalendar.route,
  )
  const singleChannelMatch = useMatchCurrentOrParentPath(channelRoute.route)
  const singleChannelScheduleMatch = useMatchCurrentOrParentPath(
    channelSchedule.route,
  )
  const isSingleChannel =
    !!singleChannelCalendarMatch ||
    !!singleChannelMatch ||
    !!singleChannelScheduleMatch
  const supportsTimeSlots = isSingleChannel || !!allChannelsCalendarMatch
  const isCalendar = singleChannelCalendarMatch || allChannelsCalendarMatch
  const organizationId = useOrganizationId()

  const [showTimeSlotsPreference, setShowTimeSlots] = useLocalStorage<
    boolean | null
  >(STORE_KEY, null)
  const { counts, loading, error } = usePostCounts({
    organizationId:
      isCalendar && showTimeSlotsPreference === null
        ? organizationId
        : undefined,
  })
  const showTimeSlotsByDefault =
    !isCalendar ||
    (!loading && !error && (counts?.queue ?? 0) + (counts?.sent ?? 0) === 0)

  if (!supportsTimeSlots) {
    return [false, (): void => undefined]
  }

  return [showTimeSlotsPreference ?? showTimeSlotsByDefault, setShowTimeSlots]
}
